import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'
import { camelKeyed } from '@/utils/params_helpers'

export const useApiClientStore = defineStore('apiClient', {
  state: () => ({
    apiClient: {
      id: null,
      name: null,
      jwt: null,
      disabled: false,
    }
  }),

  actions: {
    async fetch(apiClientId) {
      this.fetchInitiated = true

      return httpClient.get(`/api/internal/api_clients/${apiClientId}`)
        .then(response => {
          this.apiClient = response.data.api_client
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async save() {
      return await this.apiClient.id ? this.update() : this.create()
    },

    async create() {
      const { apiClient } = this

      return httpClient
        .post('/api/internal/api_clients', {
          api_client: apiClient
        })
        .then((resp) => {
          const { data: { status, api_client } } = resp

          if (status == 'success') {
            this.apiClient = api_client
            useMessagesStore().addNotice(`${api_client.name} API key created`)
          }

          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)

          throw err
        })
    },

    async update() {
      const { apiClient } = this

      return httpClient
        .patch(`/api/internal/api_clients/${apiClient.id}`, {
          api_client: apiClient
        })
        .then((resp) => {
          const { data: { api_client } } = resp

          this.apiClient = api_client
          useMessagesStore().addNotice(`${api_client.name} API key saved`)

          return resp
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)

          throw err
        })
    }
  }
})
